<form [formGroup]="form">
  <div class="aos-kendo-textarea__container-that-overrides">
    <kendo-textarea
      [maxlength]="maxLength"
      [rows]="3"
      (blur)="textareaBlurHandler()"
      formControlName="textarea"
      resizable="none"
    >
      @if (maxLengthCounterIsVisible) {
        <kendo-textarea-suffix>
          <span class="aos-max-length-counter-container">{{ maxLengthCounterText }}</span>
        </kendo-textarea-suffix>
      }
    </kendo-textarea>
  </div>
</form>
